<template>
  <span class="disabled-checkout-button">
    <submit-button
      class="btn btn-light-green checkout-button"
      default-label="Checkout Disabled"
      type="submit"
      @click.stop.prevent="openModalDialog"
    />
    <modal-dialog ref="modalDialog">
      <!-- eslint-disable vue/no-v-html -->
      <p class="holiday-schedule-notice" v-html="disabledMessage" />
      <p>
        - The CandleScience Team.
      </p>
    </modal-dialog>
  </span>
</template>

<script>
  import ModalDialog from '../modal-dialog'
  import SubmitButton from '../submit-button'

  export default {
    components: {
      ModalDialog,
      SubmitButton,
    },
    props: {
      disabledMessage: {
        type: String,
        required: true,
      },
    },
    methods: {
      openModalDialog() {
        this.$refs.modalDialog.open()
      }
    }
  }
</script>

<style lang="scss">
  @import "../../../styles/globals/variables";

  .holiday-schedule-notice {
    text-align: left;

    a {
      color: $dark-orange;
    }
  }
</style>
